import { z } from "zod"

// RFC 9562 canonical text form: lowercase hexadecimal, a supported UUID version,
// and the RFC variant. Nil, uppercase, braced, and non-hyphenated forms are rejected so
// one logical identifier has exactly one wire representation.
const CANONICAL_UUID_PATTERN =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/

const canonicalUuidSchema = z
  .string()
  .regex(CANONICAL_UUID_PATTERN, "Identifier must be a canonical lowercase UUID.")

export const commandIdSchema = canonicalUuidSchema.brand<"CommandId">()
export type CommandId = z.infer<typeof commandIdSchema>

export const tenantIdSchema = canonicalUuidSchema.brand<"TenantId">()
export type TenantId = z.infer<typeof tenantIdSchema>

export const legalEntityIdSchema = canonicalUuidSchema.brand<"LegalEntityId">()
export type LegalEntityId = z.infer<typeof legalEntityIdSchema>

export const branchIdSchema = canonicalUuidSchema.brand<"BranchId">()
export type BranchId = z.infer<typeof branchIdSchema>

export const identityIdSchema = canonicalUuidSchema.brand<"IdentityId">()
export type IdentityId = z.infer<typeof identityIdSchema>

export const membershipIdSchema = canonicalUuidSchema.brand<"MembershipId">()
export type MembershipId = z.infer<typeof membershipIdSchema>

export const platformContextIdSchema = canonicalUuidSchema.brand<"PlatformContextId">()
export type PlatformContextId = z.infer<typeof platformContextIdSchema>

export const platformOperatorIdSchema = canonicalUuidSchema.brand<"PlatformOperatorId">()
export type PlatformOperatorId = z.infer<typeof platformOperatorIdSchema>

export const platformRoleIdSchema = canonicalUuidSchema.brand<"PlatformRoleId">()
export type PlatformRoleId = z.infer<typeof platformRoleIdSchema>

export const platformRoleAssignmentIdSchema =
  canonicalUuidSchema.brand<"PlatformRoleAssignmentId">()
export type PlatformRoleAssignmentId = z.infer<typeof platformRoleAssignmentIdSchema>

export const platformApprovalIdSchema = canonicalUuidSchema.brand<"PlatformApprovalId">()
export type PlatformApprovalId = z.infer<typeof platformApprovalIdSchema>

export const platformCommandIdSchema = canonicalUuidSchema.brand<"PlatformCommandId">()
export type PlatformCommandId = z.infer<typeof platformCommandIdSchema>

export const platformAccessReviewIdSchema =
  canonicalUuidSchema.brand<"PlatformAccessReviewId">()
export type PlatformAccessReviewId = z.infer<typeof platformAccessReviewIdSchema>

export const platformAuditEventIdSchema =
  canonicalUuidSchema.brand<"PlatformAuditEventId">()
export type PlatformAuditEventId = z.infer<typeof platformAuditEventIdSchema>

export const platformOutboxEventIdSchema =
  canonicalUuidSchema.brand<"PlatformOutboxEventId">()
export type PlatformOutboxEventId = z.infer<typeof platformOutboxEventIdSchema>

export const platformSessionIdSchema = canonicalUuidSchema.brand<"PlatformSessionId">()
export type PlatformSessionId = z.infer<typeof platformSessionIdSchema>

export const tokenIdSchema = canonicalUuidSchema.brand<"TokenId">()
export type TokenId = z.infer<typeof tokenIdSchema>

export const deviceSessionIdSchema = canonicalUuidSchema.brand<"DeviceSessionId">()
export type DeviceSessionId = z.infer<typeof deviceSessionIdSchema>

export const deviceInstallationIdSchema =
  canonicalUuidSchema.brand<"DeviceInstallationId">()
export type DeviceInstallationId = z.infer<typeof deviceInstallationIdSchema>

export const actorAssertionIdSchema = canonicalUuidSchema.brand<"ActorAssertionId">()
export type ActorAssertionId = z.infer<typeof actorAssertionIdSchema>

export const entityIdSchema = canonicalUuidSchema.brand<"EntityId">()
export type EntityId = z.infer<typeof entityIdSchema>

export const correlationIdSchema = canonicalUuidSchema.brand<"CorrelationId">()
export type CorrelationId = z.infer<typeof correlationIdSchema>
